import type { ComparisonPage } from '../types';

export const funnelVsWarehouse: ComparisonPage = {
  slug: 'funnel-vs-custom-data-warehouse',
  group: 'ecomm',
  ours: 'greyfield',
  theirs: 'funnel',
  title: 'Funnel vs a custom data warehouse: marketing data hub or commerce model?',
  metaTitle: 'Funnel.io vs a Custom Ecommerce Data Warehouse (2026): Honest Comparison',
  description:
    'Funnel collects and harmonizes data from hundreds of marketing sources, with MMM and attribution as an add-on. Here is where it ends and a warehouse model begins.',
  keywords: ['funnel.io alternative', 'funnel.io vs', 'funnel.io pricing', 'funnel snowflake', 'marketing data hub'],
  published: '2026-11-03',
  updated: '2026-11-03',
  tldr:
    'Funnel is built for marketing teams and agencies that need data from many ad and analytics platforms cleaned up and sent to dashboards, with measurement as an add-on. It is strong at harmonizing marketing data. It does not ship a profit model, and Snowflake export is Enterprise-only, so brands that need commerce margin usually need modeling beyond it.',
  differences: [
    { heading: 'Marketing harmonization vs commerce modeling', body: 'Funnel maps fields from hundreds of marketing sources into a consistent shape. A build models orders, fees, refunds, and costs.' },
    { heading: 'Snowflake on Enterprise', body: 'Funnel sends to BigQuery and Redshift from its Business plan; Snowflake export needs Enterprise.' },
    { heading: 'Measurement add-on', body: 'Funnel Measure adds MMM, multi-touch attribution, and incrementality on Business and Enterprise. We do not build those.' },
  ],
  sections: [
    {
      heading: 'What Funnel does well',
      paragraphs: [
        'It lists hundreds of connectors, including Shopify, Amazon Seller Central, and TikTok Shop, with custom dimensions and metrics and an AI agent that can answer questions and build dashboards. Pricing is based on Flexpoints for connectors, accounts, and destinations, not data volume. Its measurement add-on comes from its 2024 acquisition of Adtriba.',
      ],
    },
    {
      heading: 'What still needs modeling',
      paragraphs: [
        'We found no profit or cost-of-goods model in Funnel’s pages, and its Amazon connector covers orders, sales, and returns. Margin by channel, [contribution-margin LTV](/blog/contribution-margin-ltv-by-acquisition-channel), and reconciled revenue still need a model of your costs.',
      ],
    },
  ],
  pickThem: [
    'You run marketing across many platforms and need the data harmonized.',
    'You are an agency reporting for many clients.',
    'You want MMM and attribution from the same vendor.',
  ],
  pickUs: [
    'Your priority is margin and channel P&L, not marketing measurement.',
    'You want the data and models in your own Snowflake without an Enterprise plan.',
    'Finance and operations need reports, not only marketing.',
  ],
  byTeam: [
    { team: 'In-house marketing team at a mid-size brand', pick: 'theirs', why: 'Harmonized marketing data and dashboards without engineers.' },
    { team: 'Marketing agency', pick: 'theirs', why: 'Built for many accounts and clients.' },
    { team: 'Finance-led brand on Snowflake', pick: 'ours', why: 'Commerce margin modeled in your own account.' },
  ],
  faq: [
    {
      question: 'Does a custom warehouse replace Funnel?',
      answer: 'For commerce reporting, it can. For harmonizing data from many marketing platforms and running MMM, Funnel is the stronger tool, and it can feed a warehouse.',
    },
    {
      question: 'How much does Funnel cost?',
      answer: 'Starter is from $300 a month and Business from $600 a month, billed annually, with Enterprise quoted. Cost is set by Flexpoints for connectors, accounts, and destinations. The measurement add-on starts at $2,250 a month.',
    },
  ],
  related: ['windsor-ai-vs-custom-data-warehouse', 'supermetrics-vs-custom-data-warehouse', 'improvado-vs-custom-data-warehouse'],
};
